import snakeCase from 'lodash-es/snakeCase';

import { Question, QuestionOption, QuestionSetAction } from '@/shared/types/action';
import { QUESTION_SET_LIMITS } from '@/util/validation/constants';
import { QuestionSetForm } from '@/util/validation/schemas/question-set-schemas';

export const NO_CONDITION = '__none__';

// The contract defaults `allow_other` to true, so the form always holds a boolean.
export const withChoiceDefaults = (question: Question): Question =>
  question.type === 'text' ? question : { ...question, allow_other: question.allow_other ?? true };

export const toForm = (action: QuestionSetAction | null): QuestionSetForm => ({
  title: action?.question_set?.title ?? '',
  questions: (action?.question_set?.questions ?? []).map(withChoiceDefaults),
  trigger_node_id: action?.trigger_node_id ?? '',
});

const cleanOption = ({ description, show_if, recommended, ...option }: QuestionOption) => ({
  ...option,
  ...(description && { description }),
  ...(recommended && { recommended }),
  ...(show_if && { show_if }),
});

const cleanQuestion = ({ options, allow_other, show_if, ...question }: Question): Question => ({
  ...question,
  ...(question.type !== 'text' && { options: (options ?? []).map(cleanOption), allow_other }),
  ...(show_if && { show_if }),
});

/** The saved action shape: empty optional fields are dropped, text questions carry no options. */
export const toAction = (values: QuestionSetForm): Partial<QuestionSetAction> => ({
  question_set: { title: values.title, questions: values.questions.map(cleanQuestion) },
  trigger_node_id: values.trigger_node_id || undefined,
});

/** An option value derived from its label: `Greek Food!` becomes `greek_food`. */
export const toOptionValue = (label: string) =>
  snakeCase(label).slice(0, QUESTION_SET_LIMITS.VALUE);
